import {Component, OnInit} from '@angular/core';
import {DatePipe, Location} from '@angular/common';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {InfluencerDetail} from '../../../../models/influencer';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {ReferenceDataService} from '../../../services/reference-data/reference-data.service';
import {PostOverviewComponent} from '../../post-overview/post-overview.component';
import {InfluencerPostService} from '../../../services/influencer-post/influencer-post.service';
import {CommonService} from '../../../services/common/common.service';
import {CampaignService} from '../../../services/campaign/campaign.service';
import {DiscoverService} from '../../../services/discover/discover.service';
import {ModalService} from '../../../services/modal/modal.service';
import {PlaceholderVisibilityService} from '../../../services/placeholder-visibility/placeholder-visibility.service';
import {PdfViewerService} from '../pdf-viewer.service';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';
import {EventTrackerService} from '../../../services/event-tracker/event-tracker.service';
import {TranslateService} from '@ngx-translate/core';
import {CacheService} from '../../../services/cache/cache.service';

declare var require: any;
export enum ServiceCounter {
  init = 0,
  max = 6,
  renderTimeout = 500
}

@Component({
  selector: 'post-overview-pdf-viewer',
  templateUrl: './post-overview-pdf-viewer.component.html',
  styleUrls: ['./post-overview-pdf-viewer.component.scss']
})

export class PostOverviewPdfViewerComponent extends PostOverviewComponent implements OnInit {
  public influencer: InfluencerDetail;

  constructor(
    route: ActivatedRoute,
    router: Router,
    location: Location,
    influencerPostService: InfluencerPostService,
    commonService: CommonService,
    influencerService: InfluencerService,
    userService: UserService,
    campaignService: CampaignService,
    referenceDataService: ReferenceDataService,
    discoverService: DiscoverService,
    modalService: ModalService,
    placeholderService: PlaceholderVisibilityService,
    pdfViewerService: PdfViewerService,
    pdfService: PdfExportService,
    translate: TranslateService,
    cacheService: CacheService,
    eventTracker: EventTrackerService,
    private pdfExportService: PdfExportService,
  ) {
    super(
      route,
      router,
      location,
      influencerPostService,
      commonService,
      influencerService,
      userService,
      campaignService,
      referenceDataService,
      discoverService,
      modalService,
      placeholderService,
      pdfViewerService,
      pdfService,
      translate,
      cacheService,
      eventTracker
    );

  }

  ngOnInit() {
    // disable highchart animation
    const highcharts = require('highcharts');
    highcharts.setOptions({
      chart: {
        animation: false
      },
      plotOptions: {
        series: {
          animation: false
        }
      }
    });
    super.ngOnInit();

    this.pdfExportService.triggerIncrementReportReady.subscribe((numberReportReady) => {
      if (numberReportReady === ServiceCounter.max) {
        console.log(' ***************************************** POST READY TO EXPORT PDF *****************************************');
        setTimeout(() => {
          this.pdfReady();
        }, ServiceCounter.renderTimeout);
      }
    });

  }

  private pdfReady () {
    if (window && typeof (<any>window).pdfReady === 'function') {
      setTimeout(() => {
        (<any>window).pdfReady();
      }, ServiceCounter.renderTimeout);
    }
  }

  get logoImage() {
    return this.userService.logoImage;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/post-overview-pdf-viewer/post-overview-pdf-viewer.component.ts